var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"image-view"}},[(_vm.image)?_c('img',{staticStyle:{"height":"100vh"},attrs:{"src":_vm.image,"alt":"Image"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }